import { useNavigate } from 'react-router';

import { DraftNotice } from 'components/ui/draft-notice';

export default function PartialRecognition({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();

  return (
    <DraftNotice
      storageKey="partialRecognitionMinimized"
      title="Você possui um reconhecimento em preenchimento"
      actionLabel="Continuar Reconhecimento"
      onResume={() => navigate('/reconhecer')}
      closeOnResume
      onClose={onClose}
    >
      <p className="m-0">Identificamos que você iniciou o envio de um reconhecimento, mas ainda não concluiu.</p>
      <p className="m-0">Suas informações foram salvas automaticamente para que você possa continuar de onde parou.</p>
      <p className="m-0">Clique no botão abaixo para retomar o preenchimento e finalizar o envio.</p>
    </DraftNotice>
  );
}
